(() => {
  const roots = () => document.querySelectorAll('[data-localization-float]');

  const appendChatStyle = (shadow, attribute, cssText) => {
    if (!shadow || shadow.querySelector(`style[${attribute}]`)) return;
    const style = document.createElement('style');
    style.setAttribute(attribute, '');
    style.textContent = cssText;
    shadow.append(style);
  };

  const ensureChatActivatorStyles = (chatHost) => {
    const outerShadow = chatHost?.shadowRoot;
    if (!outerShadow) return;

    const contrastCss = `
      .activator__label,
      .activator__icon {
        color: #f5f5f2 !important;
        -webkit-text-fill-color: #f5f5f2 !important;
      }
      .activator__label {
        display: inline-flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        white-space: nowrap !important;
        margin-left: 0 !important;
        text-align: left !important;
      }
      .activator,
      [part="activator"] {
        justify-content: flex-start !important;
        text-align: left !important;
        gap: 8px !important;
        padding-left: 12px !important;
        padding-right: 12px !important;
      }
      .activator__icon {
        flex: 0 0 16px !important;
        margin: 0 !important;
      }
      .activator__icon svg,
      .activator__icon svg * {
        color: #f5f5f2 !important;
        stroke: currentColor !important;
      }
    `;
    const positionCss = `
      .activator-nudge {
        display: grid !important;
        position: fixed !important;
        left: max(var(--slf-chat-left, 24px), env(safe-area-inset-left)) !important;
        right: auto !important;
        bottom: max(88px, env(safe-area-inset-bottom)) !important;
        margin-left: 0 !important;
        transform: none !important;
        z-index: 2 !important;
        width: 88px !important;
        height: 46px !important;
      }
      .activator-nudge--right {
        display: grid !important;
        position: fixed !important;
        left: max(var(--slf-chat-left, 24px), env(safe-area-inset-left)) !important;
        right: auto !important;
        bottom: max(88px, env(safe-area-inset-bottom)) !important;
        width: 88px !important;
        height: 46px !important;
      }
      /* Keep the Inbox trigger mounted while its panel is open. Shopify Inbox
         can toggle the wrapper to hidden during the open-state transition. */
      :host([open]) .activator-nudge,
      :host([open]) .activator-nudge--right,
      :host([open]) .activator-nudge [part="activator"],
      :host([open]) .activator-nudge .activator,
      :host([open]) .activator-nudge--right [part="activator"],
      :host([open]) .activator-nudge--right .activator,
      shopify-chat[open] .activator-nudge,
      shopify-chat[open] .activator-nudge--right,
      shopify-chat[open] .activator-nudge [part="activator"],
      shopify-chat[open] .activator-nudge .activator,
      shopify-chat[open] .activator-nudge--right [part="activator"],
      shopify-chat[open] .activator-nudge--right .activator {
        display: grid !important;
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: auto !important;
      }
      .activator-nudge [part="activator"],
      .activator-nudge .activator {
        display: flex !important;
        position: static !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
        margin-left: 0 !important;
        transform: none !important;
        width: 88px !important;
        min-width: 88px !important;
        max-width: 88px !important;
        height: 46px !important;
        min-height: 46px !important;
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: auto !important;
        scale: 1 !important;
      }
      .panel.panel--right {
        left: calc(var(--slf-chat-left, 24px) + 100px) !important;
        right: auto !important;
        bottom: max(88px, env(safe-area-inset-bottom)) !important;
        width: min(500px, calc(100vw - var(--slf-chat-left, 24px) - 112px)) !important;
        max-width: calc(100vw - var(--slf-chat-left, 24px) - 112px) !important;
        max-height: calc(100dvh - 32px) !important;
        z-index: 2147483647 !important;
      }
      .activator__label {
        display: inline-flex !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
    `;

    appendChatStyle(outerShadow, 'data-senbeder-chat-contrast', contrastCss);
    appendChatStyle(outerShadow, 'data-senbeder-chat-position', positionCss);

    const applyRuntimeStyles = () => {
      const runtimeShadow = outerShadow.querySelector('shopify-agent-runtime')?.shadowRoot;
      if (!runtimeShadow) return false;
      appendChatStyle(runtimeShadow, 'data-senbeder-chat-contrast', contrastCss);
      appendChatStyle(runtimeShadow, 'data-senbeder-chat-position', positionCss);
      return true;
    };

    /* Inbox mounts its runtime shadow lazily, usually after the first Chat click. */
    if (!applyRuntimeStyles() && chatHost.dataset.senbederRuntimeStylePolling !== 'true') {
      chatHost.dataset.senbederRuntimeStylePolling = 'true';
      let attempts = 0;
      const pollRuntime = () => {
        attempts += 1;
        if (applyRuntimeStyles() || attempts >= 600) {
          chatHost.dataset.senbederRuntimeStylePolling = 'false';
          return;
        }
        window.requestAnimationFrame(pollRuntime);
      };
      window.setTimeout(pollRuntime, 0);
    }
  };

  const findChatActivator = () => {
    const chatHost = document.querySelector('shopify-chat');
    if (!chatHost?.shadowRoot) return null;
    ensureChatActivatorStyles(chatHost);
    return chatHost.shadowRoot.querySelector('[part="activator"], .activator')
      || chatHost.shadowRoot.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part="activator"], .activator');
  };

  const visibleBottom = (element) => {
    if (!element) return null;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 ? rect.bottom : null;
  };

  const positionPanelOverlay = (root) => {
    const rootRect = root.getBoundingClientRect();
    const bottoms = [rootRect.bottom];
    const contactBottom = visibleBottom(document.querySelector('.senbeder-contact-float'));
    const chatBottom = visibleBottom(findChatActivator());
    if (contactBottom !== null) bottoms.push(contactBottom);
    if (chatBottom !== null) bottoms.push(chatBottom);
    const overlap = Math.max(0, Math.ceil(Math.max(...bottoms) - rootRect.bottom + 8));
    root.style.setProperty('--slf-panel-overlap', `${overlap}px`);
  };

  const positionAboveChat = (root) => {
    const activator = findChatActivator();
    if (!activator) {
      root.style.setProperty('--slf-bottom', window.innerWidth <= 749 ? '116px' : '146px');
      root.style.setProperty('--slf-left', window.innerWidth <= 749 ? '16px' : '24px');
      root.style.removeProperty('right');
      positionPanelOverlay(root);
      return;
    }
    const rect = activator.getBoundingClientRect();
    const bottom = Math.max(88, Math.round(window.innerHeight - rect.top + 7));
    root.style.setProperty('--slf-bottom', `${bottom}px`);
    root.style.setProperty('--slf-left', window.innerWidth <= 749 ? '16px' : '24px');
    root.style.removeProperty('--slf-right');
    root.style.removeProperty('right');
    root.style.setProperty('--slf-tool-width', `${Math.round(rect.width)}px`);
    positionPanelOverlay(root);
  };

  const init = (root) => {
    if (root.dataset.localizationFloatInitialized === 'true') return;
    root.dataset.localizationFloatInitialized = 'true';

    const trigger = root.querySelector('[data-localization-float-trigger]');
    const panel = root.querySelector('[data-localization-float-panel]');
    const closeButton = root.querySelector('[data-localization-float-close]');
    const languageSelect = root.querySelector('[data-localization-language]');
    const quoteButton = root.querySelector('[data-localization-quote]');
    if (!trigger || !panel || !closeButton) return;

    let hideTimer;
    const isOpen = () => trigger.getAttribute('aria-expanded') === 'true';
    const open = () => {
      window.clearTimeout(hideTimer);
      const contactTrigger = document.querySelector('[data-contact-float-trigger][aria-expanded="true"]');
      contactTrigger?.click();
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => {
        root.classList.add('is-open');
        closeButton.focus({ preventScroll: true });
      });
    };
    const close = (restoreFocus = true) => {
      root.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      hideTimer = window.setTimeout(() => {
        if (!isOpen()) panel.hidden = true;
      }, 190);
      if (restoreFocus) trigger.focus({ preventScroll: true });
    };

    trigger.addEventListener('click', () => (isOpen() ? close() : open()));
    closeButton.addEventListener('click', () => close());
    document.addEventListener('pointerdown', (event) => {
      if (isOpen() && !root.contains(event.target)) close(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) close();
    });
    window.addEventListener('resize', () => positionAboveChat(root), { passive: true });
    window.addEventListener('pageshow', () => {
      if (isOpen()) close(false);
      positionAboveChat(root);
    });

    languageSelect?.addEventListener('change', () => languageSelect.form?.submit());

    quoteButton?.addEventListener('click', () => {
      const catalog = document.querySelector('[id^="SenbederProductCatalog-"]');
      catalog?.querySelector('[data-open-cart]')?.click();
    });
    positionAboveChat(root);

    const observer = new MutationObserver(() => positionAboveChat(root));
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  const initAll = () => roots().forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
